import { useDocumentsPreviewApi } from 'infrastructure/api';

const IMAGE_PREVIEW_TYPES = ['jpeg', 'jpg', 'png', 'gif'];
const AVAILABLE_PREVIEW_TYPES = ['pdf', 'rtf', 'doc', 'docx', 'txt', 'md'];

const useDocumentPreviewService = () => {
  const { sendPostRequest } = useDocumentsPreviewApi();

  const isPreviewAvailable = (type: string): boolean => AVAILABLE_PREVIEW_TYPES.includes(type);
  const isPreviewImage = (type: string): boolean => IMAGE_PREVIEW_TYPES.includes(type);
  const isMd = (type: string): boolean => type === 'md';

  const getDocumentPreviewBlob = async (preSignedUrl: string) => {
    const request = await sendPostRequest('/convert', {
      preSignedUrl,
    });

    return request.blob();
  };

  return { getDocumentPreviewBlob, isMd, isPreviewAvailable, isPreviewImage };
};

export default useDocumentPreviewService;
